import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    list: {}
}

export const dynamicAdjustmentsSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {
        setDynamicAdjustments: (state, { payload }) => {
            let { list } = payload;
            state.list = list
        },
    },
})

// Action creators are generated for each case reducer function
export const { setDynamicAdjustments } = dynamicAdjustmentsSlice.actions

export default dynamicAdjustmentsSlice.reducer